import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  useCustomerRecoverPassword,
  useSettings,
} from '@backpackjs/storefront';

import { Spinner, Body, Button } from '../../../snippets';

export function ForgotPasswordForm({ setIsForgotPassword }) {
  const { finished, recoverPassword, reset, resetTimer, started, success } =
    useCustomerRecoverPassword();
  const settings = useSettings();

  const [message, setMessage] = useState('');

  const { heading, postSubmissionText, subtext } = {
    ...settings?.account?.forgot,
  };

  const buttonText = useMemo(() => {
    if (finished) {
      resetTimer.current = setTimeout(() => {
        if (reset) reset();
        clearTimeout(resetTimer.current);
      }, 3000);
      return success ? 'Submitted' : 'Submitted';
    }
    return started ? 'Submitting' : 'Submit';
  }, [finished, started, success]);

  const handleRecoverPassword = useCallback(async (event) => {
    event.preventDefault();
    const { email } = event.target;
    await recoverPassword({ email: email.value });
  }, []);

  useEffect(() => {
    if (finished) {
      setMessage(postSubmissionText);
      setTimeout(() => {
        setMessage('');
        setIsForgotPassword(false);
      }, 3000);
    }
  }, [finished]);

  return (
    <div className="mx-auto max-w-lg text-center">
      <div className="mb-4 flex items-center">
        <hr className="grow border-[var(--text)]" />
        <Body variant="medium" className="px-4 text-center">
          {heading}
        </Body>
        <hr className="grow border-[var(--text)]" />
      </div>

      <div className="mb-6 flex flex-col gap-4">
        {subtext && <p className="text-center text-sm">{subtext}</p>}
      </div>

      <form
        className="mx-auto flex w-full flex-col gap-4"
        onSubmit={handleRecoverPassword}
      >
        <label htmlFor="email">
          <span className="input-label sr-only">Email</span>

          <input
            className="w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0"
            name="email"
            placeholder="your@email.com"
            type="email"
            required
          />
        </label>

        <Button
          ariaLabel="Submit email for password recovery"
          theme="primary"
          variant="filled"
          type="submit"
          className="mx-auto mt-6 flex w-full max-w-[250px] items-center justify-center"
        >
          {started ? <Spinner /> : buttonText}
        </Button>
      </form>

      <button
        aria-label="Cancel"
        className="text-underline mt-4 text-center text-sm font-bold"
        onClick={() => setIsForgotPassword(false)}
        type="button"
      >
        Cancel
      </button>

      {message && <p className="mt-4 text-center text-sm">{message}</p>}
    </div>
  );
}

ForgotPasswordForm.displayName = 'ForgotPasswordForm';
